import { render } from "./StudentDemeritsDataTable.vue?vue&type=template&id=1657a99d&scoped=true"
import script from "./StudentDemeritsDataTable.vue?vue&type=script&lang=js"
export * from "./StudentDemeritsDataTable.vue?vue&type=script&lang=js"

import "./StudentDemeritsDataTable.vue?vue&type=style&index=0&id=1657a99d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1657a99d"]])

export default __exports__